export default function Hero() {
  return (
    <section className="section pt-16 pb-24 md:pt-24 md:pb-32 relative" id="Hero">
      {/* soft light orbs */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-10 -left-10 w-72 h-72 rounded-full bg-sunrise-500/20 blur-3xl"></div>
        <div className="absolute top-10 right-0 w-96 h-96 rounded-full bg-blush-500/20 blur-3xl"></div>
      </div>

      <div className="grid md:grid-cols-2 gap-10 items-center">
        {/* IMAGE — mobile first */}
        <div className="relative order-1 md:order-2">
          <div className="glass p-2 rounded-[28px]">
            <img
              className="rounded-[24px] aspect-[4/5] object-cover"
              src="/images/banner-sunrise.jpg"
              alt="Makeup artist perfecting a dewy, glowing look"
              loading="eager"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 glass px-5 py-3">
            <p className="text-sm"><span className="font-semibold">4.9/5</span> from 220+ happy clients</p>
          </div>
        </div>

        {/* TEXT — desktop first */}
        <div className="max-w-xl order-2 md:order-1">
          <h1 className="font-display text-5xl md:text-6xl leading-tight">
            Glow like <span className="text-sunrise-300">sunrise</span>, stay flawless all day.
          </h1>
          <p className="mt-5 text-white/80 leading-relaxed">
            Bridal, editorial, and party looks crafted with skin-first techniques and luxury products.
            Refined, radiant, utterly you.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#booking" className="btn-primary">Book your glow</a>
            <a href="#portfolio" className="btn-ghost">See our work</a>
          </div>

          <ul className="mt-8 flex flex-wrap gap-6 text-sm text-white/70">
            <li>✨ HD & Airbrush</li>
            <li>🎨 Custom color matching</li>
            <li>🌿 Sensitive-skin friendly</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
